import { useRef } from 'react';

import { randomUUID } from 'expo-crypto';
import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';
import { useUtensils } from 'features/cart/hooks/use-utensils';
import { MinimalCartEntryType } from 'features/cart/types';
import { AlertDialog } from 'native-base';
import { Typography } from 'ucl';
import { ListItemCheckboxGroup } from 'ucl/components/list-item-checkbox-group';

import { t } from 'state/intl/translations';
import { emptySanityImage } from 'utils/sanity';

export const CartDebugManageUtensilsModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const cancelRef = useRef(null);
  const { utensils, loading } = useUtensils();

  const { cartEntries, addItemToMinimalCart, removeItemFromMinimalCart } = useMinimalCart();

  const selectedItems = cartEntries
    .filter(entry => entry.type === MinimalCartEntryType.extra)
    .map(entry => entry.id);

  const listItems = utensils?.map(utensil => ({
    value: utensil.id,
    label: utensil.name + (utensil.isAvailable ? '' : ` (${t('unavailable')})`),
    accessibilityLabel: utensil.name,
    disabled: !utensil.isAvailable,
  }));

  const handleChange = (nextValues: string[]) => {
    cartEntries.forEach(entry => {
      if (entry.type === MinimalCartEntryType.extra) {
        removeItemFromMinimalCart(entry);
      }
    });
    nextValues.forEach(value => {
      const utensil = utensils.find(utensil => utensil.id === value);
      addItemToMinimalCart({
        id: value,
        cartId: randomUUID(),
        quantity: 1,
        name: utensil?.name ?? '',
        image: emptySanityImage(),
        url: '',
        type: MinimalCartEntryType.extra,
        children: [],
      });
    });
  };

  return (
    <AlertDialog leastDestructiveRef={cancelRef} isOpen={isOpen} onClose={onClose}>
      <AlertDialog.Content>
        <AlertDialog.CloseButton />
        <AlertDialog.Header>Choose Utensils</AlertDialog.Header>
        <AlertDialog.Body>Utensils</AlertDialog.Body>
        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          <ListItemCheckboxGroup
            value={selectedItems}
            onChange={handleChange}
            listItems={listItems}
          />
        )}
      </AlertDialog.Content>
    </AlertDialog>
  );
};
